module.exports = __webpack_public_path__ + "static/img/preview-6.9e34c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/preview-6.png
// module id = 9qoC
// module chunks = 35